import axios from 'axios';

type Props = {
    eventUrl: string;
    rotaryCd: string;
}

/**
 * イベントへ参加予定の会員情報を取得するAPI
 */
export async function getEventJoinUsers({eventUrl, rotaryCd}: Props){
    const response = await axios.get(process.env.REACT_APP_PATH + `/users/member/event/join`, {
        params: {
            rotaryCd: rotaryCd,
            url: eventUrl
        }
    })

    return JSON.parse(JSON.stringify(response.data))
}